<div class="card">
  <!-- FULL-WIDTH HEADER -->
  <div class="card-header">
    <mat-icon>content_copy</mat-icon>
    Copy Order to Cubi division...
  </div>

  <!-- CARD CONTENT -->
  <div class="card-content">
    <div class="order-input">
      <mat-icon class="order-input-icon">receipt_long</mat-icon>
      <input type="number" placeholder="Order ID…" [(ngModel)]="OrderID" autocomplete="off" />
    </div>

    <mat-checkbox
      [(ngModel)]="IsCopyToLocal"
      floatingTooltip="{{ 'app.administration.utilIsCopyToLocalToolTip' | translate }}"
      style="margin-left: -10px"
    >
      Copy to local
    </mat-checkbox>
  </div>

  <!-- ACTIONS -->
  <div class="card-actions">
    <button color="warn" mat-raised-button mat-dialog-close>CANCEL</button>

    <button mat-raised-button color="primary" (click)="copyOrder()" [disabled]="!OrderID || isProcessing">
      <mat-icon>play_arrow</mat-icon>
      Copy
    </button>
  </div>
</div>

<!-- EXISTING PROCESSING OVERLAY -->
@if (isProcessing) {
  <div class="processing-wrapper">
    <div class="processing-circle"></div>
    <div class="processing-text">
      {{ "app.misc.processing" | translate }}
    </div>
  </div>
}
